export const states = [
    'دمشق' , 'ريف دمشق' , 'القنيطرة' 
    , 'درعا' , 'السويداء' , 'حمص' 
    , 'طرطوس' , 'اللاذقية' , 'حماة' 
    , 'إدلب' , 'حلب' , 'الرقة' 
    , 'دير الزور' , 'الحسكة'
];

export const regions = {
    'دمشق': [
        'منطقة دمشق',
        'منطقة الروضة',
        'منطقة المالكي',
        'منطقة الشعلان',
        'منطقة الصالحية',
        'منطقة الميدان',
        'منطقة برزة',
        'منطقة الشاغور',
        'منطقة القابون',
        'منطقة المزة',
        'منطقة دمر',
        'منطقة القدم',
        'منطقة القنوات',
        'منطقة المهاجرين',
        'منطقة اليرموك',
        'منطقة جوبر',
        'منطقة ركن الدين',
        'منطقة ساروجة',
        'منطقة كفرسوسة',
    ],
    'ريف دمشق': [
        'منطقة ريف دمشق',
        'منطقة النبك',
        'منطقة القطيفة',
        'منطقة التل',
        'منطقة قدسيا',
        'منطقة الزبداني',
        'منطقة دوما',
        'منطقة داريا',
        'منطقة قطنا',
        'منطقة يبرود',
        'منطقة عربين',
    ],
    'القنيطرة': [
        'منطقة القنيطرة',
        'منطقة فيق'
    ],
    'درعا': [
        'منطقة درعا',
        'منطقة الصنمين',
        'منطقة أزرع'
    ],
    'السويداء': [
        'منطقة السويداء',
        'منطقة صلخد',
        'منطقة شهبا'
    ],
    'حمص': [
        'منطقة حمص',
        'منطقة المخرم',
        'منكقة القصير',
        'منطقة تدمر',
        'منطقة الرستن'
    ],
    'طرطوس': [
        'منطقة طرطوس',
        'منطقة الشيخ بدر',
        'منطقة بانياس',
        'منطقة دريكيش',
    ],
    'اللاذقية': [
        'منطقة اللاذقية',
        'منطقة الحفة',
        'منطقة جبلة',
    ],
    'حماة': [
        'منطقة حماة',
        'منطقة السلمية',
        'منطقة مصياف',
        'منطقة محردة'
    ],
    'إدلب': [
        'منطقة إدلب',
        'منطقة أريحا',
        'منطقة معرة النعمان'
    ],
    'حلب': [
        'منطقة حلب',
        'منطقة أعزاز',
        'منطقة الباب',
        'منطقة الأتارب',
        'منطقة عفرين',
        'منطقة عبن العرب',
    ],
    'الرقة': [
        'منطقة الرقة',
        'منطقة الثورة',
        'منطقة تل أبيض'
    ],
    'دير الزور': [
        'منطقة دير الزور',
        'منطقة البوكمال',
        'منطقة الميادين'
    ],
    'الحسكة': [
        'منطقة الحسكة',
        'منطقة المالكية',
        'منطقة القامشلي',
        'منطقة رأس العين'
    ]
};

export const genders = ['ذكر' , 'انثى'];

export const employeeCategory = ['موظف' , 'متطوع'];

export const jobStates = ['مدير' , 'مدير مشاريع' , 'موظف'];

export const projectCategories = [
    {
        id: 1,
        name: 'تعليم'
    },
    {
        id: 2,
        name: 'غذاء'
    },
    {
        id: 3,
        name: 'أيتام'
    },
    {
        id: 4,
        name: 'أغاثة'
    },
    {
        id: 5,
        name: 'كسوة'
    },
    {
        id: 6,
        name: 'صحة'
    },
    {
        id: 7,
        name: 'إسكان'
    },
    {
        id: 8,
        name: 'رمضان'
    },
    {
        id: 9,
        name: 'مساجد'
    },
    {
        id: 10,
        name: 'ذوي الهمم'
    }
];

export const socialStatuses = ['اعزب' , 'متزوج'];

export const  projectTypes = ['عام' , 'خاص']